import axios from 'axios';
import { createApp } from 'vue';
import VueAxios from 'vue-axios';
import App from './App.vue';
import clickOutside from './helpers/click-outside';
import interceptor from './helpers/httpInterceptor';
import router from './router';
import { pinia } from './stores';
import 'bootstrap/dist/css/bootstrap.css';
import 'reflect-metadata';
import 'moment/locale/nl';

interceptor();

const app = createApp(App);

app
    .directive('click-outside', clickOutside)
    .use(pinia)
    .use(router)
    .use(VueAxios, axios)
    .mount('#app');
